import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import primeiraLetraMaiuscula from '../../../tools/primeiraLetraMaiuscula';
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    controlaPaper: {
        padding: 20,
    },
    controlaContainer: {
        paddingTop: 20,
        height: '100%',
        backgroundColor: '#f1f1f1'
    },
    controlaPaperFilho: {
        padding: 20
    }
}))


export function EstruturaAjuda(props) {

    const classes = useStyles();

    const { categoria, titulo, children } = props;


    return (
        <Paper className={classes.controlaPaper}>
            <Typography
                component='h4'
                variant='h4'
                color="primary"
                gutterBottom
                align="center"
            >
                {primeiraLetraMaiuscula(categoria)}
            </Typography>
            <Paper variant="outlined" className={classes.controlaPaperFilho}>
                <Typography
                    component='h5'
                    variant='h5'
                    color="secondary"
                    gutterBottom
                    align="center"
                >
                    {titulo}
                </Typography>
                {children}
            </Paper>
        </Paper>
    )
}


function RoteirizaAjuda(props) {

    const classes = useStyles();

    let categoria = props.match.params.categoria;
    let campo = props.match.params.campo;

    function RetornaAjuda(props) {

        switch (categoria) {
            case 'produto':
                switch (campo) {
                    case 'ncm':
                        return (
                            <EstruturaAjuda
                                titulo="NCM"
                                categoria={categoria}
                            >

                            </EstruturaAjuda>
                        )
                    default:
                        return <div>Rota inválida</div>
                }
            default:
                return <div>Rota inválida</div>
        }
    }

    return (
        <Container className={classes.controlaContainer}>
            <RetornaAjuda />
        </Container>
    )
}

export default RoteirizaAjuda;